"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var appendPathKey_1 = __importDefault(require("./appendPathKey"));
var getArrayValue_1 = __importDefault(require("./getArrayValue"));
var getValue_1 = __importDefault(require("./getValue"));
var getValueFromIndicies_1 = __importDefault(require("./getValueFromIndicies"));
/**
 * Finds the next value in the object based on the given segment.
 * @param {NextValue} result - The result object containing the current value, current path, and full path.
 * @param {string} segment - The segment of the path to process.
 * @returns {NextValue} The updated result object with the next value, current path, and full path.
 */
var findNextValue = function (result, segment) {
    var value = result.value, currentPath = result.currentPath;
    var fullPath = result.fullPath;
    if (value === undefined)
        return result;
    if (segment.startsWith("[")) {
        value = (0, getValueFromIndicies_1.default)(value, segment, currentPath, fullPath);
        currentPath = (0, appendPathKey_1.default)(currentPath, segment);
    }
    else if (segment.includes("[")) {
        value = (0, getArrayValue_1.default)(value, segment, currentPath, fullPath);
        currentPath = (0, appendPathKey_1.default)(currentPath, segment);
    }
    else {
        currentPath = (0, appendPathKey_1.default)(currentPath, segment);
        value = (0, getValue_1.default)(value, segment, currentPath, fullPath);
    }
    return {
        value: value,
        currentPath: currentPath,
        fullPath: fullPath,
    };
};
exports.default = findNextValue;
